import { Col, Row } from 'antd';
import './AboutUs.scss';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="flex p-80 pb-40 self-stretch flex-col items-center gap-40 bg-fills-white">
        <h1>
          {t(
            'Fitta là một công ty nội thất, chuyên thiết kế và thi công nội thất, đồng thời cung cấp các sản phẩm nội thất chất lượng cao'
          )}
        </h1>
        <div className="flex flex-col items-start gap-16">
          <span className="text-body-medium">
            {t(
              'Thành lập từ năm 2022, Fitta mang đến giải pháp nội thất toàn diện từ thiết kế đến thi công. Fitta có đủ năng lực để biến đổi không gian sống đáp ứng được sự căn bằng giữ thẩm mỹ và công năng từ đó mang đến cho gia chủ trải nghiệm sống tốt hơn'
            )}
          </span>
          <span className="text-body-medium">
            {t(
              'Fitta chia thành 2 mảng dịch vụ chính để mang đến trải nghiệm mua sắm toàn diện cho người dùng'
            )}
          </span>
        </div>
      </section>
      <section className="flex self-stretch p-24 flex-col justify-center items-center gap-40 bg-fills-white">
        <div
          className="flex p-24 flex-col items-center gap-40 self-stretch rounded-[8px]"
          style={{
            backgroundImage: "url('/assets/images/bg-swiper-slide1.svg')",
            backgroundPosition: 'top center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="flex items-start gap-40 self-stretch">
            <div
              className="flex items-start gap-16 grow"
              style={{ height: '200px' }}
            >
              <div className="flex flex-col justify-center items-end gap-16 grow self-stretch">
                <span className="text-headline-small">
                  {t('Nội thất Fitta')}
                </span>
                <span className="text-body-medium text-end">
                  {t(
                    'Cung cấp dịch vụ tư vấn, thiết kế và thi công nội thất, từ phần thô cho đến hoàn thiện, với đội ngũ KTS giàu kinh nghiệm và đội thợ lành nghề.'
                  )}
                </span>
              </div>
              <div className="flex p-24 flex-col justify-center items-center gap-40 self-stretch">
                <img
                  src="/assets/images/rect_logo_la_nha.png"
                  alt="logo Fitta"
                  style={{ width: '120px', height: '120px' }}
                />
              </div>
            </div>
            <div
              className="flex items-start gap-16 grow"
              style={{ height: '200px' }}
            >
              <div className="flex p-24 flex-col justify-center items-center gap-40 self-stretch">
                <img
                  src="/assets/images/rect_logo_ln_decor.png"
                  alt="logo Fitta"
                  style={{ width: '120px', height: '120px' }}
                />
              </div>
              <div className="flex flex-col justify-center items-start gap-16 grow self-stretch">
                <span className="text-headline-small">
                  {t('Nội thất Fitta')}
                </span>
                <span className="text-body-medium text-start">
                  {t(
                    'Cung cấp dịch vụ tư vấn, thiết kế và thi công nội thất, từ phần thô cho đến hoàn thiện, với đội ngũ KTS giàu kinh nghiệm và đội thợ lành nghề.'
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flex flex-col self-stretch items-center gap-32 py-40 px-80">
        <Row gutter={40} className="self-stretch">
          <Col span={12}>
            <div
              className="flex grow rounded-[8px]"
              style={{
                height: '420px',
                backgroundImage: "url('/assets/images/content.webp')",
                backgroundPosition: 'top center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
          </Col>
          <Col span={12}>
            <div className="flex flex-col justify-center items-start gap-16 grow self-stretch">
              <h2>{t('Nhân sự giàu kinh nghiệm')}</h2>
              <span className="text-body-medium">
                {t(
                  'Đội ngũ KTS trên 5 năm kinh nghiệm và 16 đội thợ lành nghề sản xuất cố định để theo kịp tiến độ sản xuất, liên tục được đào tạo và cập nhật về công nghệ, kỹ thuật để nâng cao tay nghề.'
                )}
              </span>
            </div>
          </Col>
        </Row>
        <Row gutter={40} className="self-stretch">
          <Col span={12}>
            <div className="flex flex-col justify-center items-start gap-16 grow self-stretch">
              <h2>{t('Xưởng sản xuất 1200m2')}</h2>
              <span className="text-body-medium">
                {t(
                  'Quy mô trên 1200m2 với kho bãi tách riêng, đảm bảo quy trình khép kín từ lắp đặt, kiểm tra, đến thi công sản xuất. Các thiết bị máy móc công nghệ tiên tiến từ Đức, Nhật Bản.'
                )}
              </span>
            </div>
          </Col>
          <Col span={12}>
            <div
              className="flex grow rounded-[8px]"
              style={{
                height: '420px',
                backgroundImage: "url('/assets/images/content1.webp')",
                backgroundPosition: 'top center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
          </Col>
        </Row>
        <Row gutter={40} className="self-stretch">
          <Col span={12}>
            <div
              className="flex grow rounded-[8px]"
              style={{
                height: '420px',
                backgroundImage: "url('/assets/images/content2.webp')",
                backgroundPosition: 'top center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
          </Col>
          <Col span={12}>
            <div className="flex flex-col justify-center items-start gap-16 grow self-stretch">
              <h2>{t('Showroom trải nghiệm')}</h2>
              <span className="text-body-medium">
                {t(
                  'Là một trong những showroom mang lại trải nghiệm mua sẳm tốt nhất hiện nay. Với diện tích hơn 800m2, tách biệt các không gian thành 10 phong cách nội thất khác nhau, cùng với 1 phòng vật liệu và tư vấn.'
                )}
              </span>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default AboutUs;
